import type { UserB2bDoc } from "@/Modules/Models/Domain/User";

import { setUserB2bDocs } from "@/Services/TherapyApi/Users";

import useUserStore from "@/Modules/User/Store";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

async function setB2bDocsAH() {
  const userStore = useUserStore();

  try {
    const docs = transform(userStore.userB2bDocs);

    await setUserB2bDocs(docs);

    userStore.userB2bDocs = [];
  } catch (e) {
    danger(e);
  }
}

function transform(userB2bDocs: UserB2bDoc[]): string[] {
  let result: string[] = [];

  if (hasValue(userB2bDocs)) {
    result = userB2bDocs.map((doc) => (doc.checked ? doc.uuid : ""));
  }

  return result;
}

export default setB2bDocsAH;
